import { Pipe, PipeTransform } from '@angular/core';

const METRICS = ['K', 'M', 'G'];

@Pipe({
    name: 'metric'
})
export class MetricPipe implements PipeTransform {

    transform(value: number): string {
        let i;

        if (value >= 1000) {
            value = value / 1000;
            i = 0;
        }

        if (value >= 1000) {
            value = value / 1000;
            i = 1;
        }

        if (value >= 1000) {
            value = value / 1000;
            i = 2;
        }

        return `${ value }${ METRICS[i] }`;
    }

}
